import { render, staticRenderFns } from "./AddPurposePopup.vue?vue&type=template&id=534ce1bf&"
import script from "./AddPurposePopup.vue?vue&type=script&lang=js&"
export * from "./AddPurposePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports